/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import { Col } from 'reactstrap';
import 'spinkit/spinkit.css';

class Spinners extends Component {
  render() {
    return (
      <div
        className="animated loader"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Col lg="12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="sk-chase">
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
          </div>
        </Col>
      </div>
    );
  }
}

export default Spinners;
